module.exports = __webpack_public_path__ + "static/img/solutions1.4e833e17.png";